import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServicesHero from "./sections/ServicesHero";
import ServicesList from "./sections/ServicesList";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServicesHero />
      <ServicesList />
      <Footer />
    </div>;
}